import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";

function FolioFields({ handleSubmit, handleChange, values, touched, errors }) {
  const navigate = useNavigate();

  return (
    <Form noValidate>
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="folioContado">
          <Form.Label>Folio Contado</Form.Label>
          <Form.Control
            type="text"
            name="folioContado"
            placeholder="Folio contado"
            value={values.folioContado}
            onChange={handleChange}
            isInvalid={!!errors.folioContado && touched.folioContado}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.folioContado}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="folioCredito">
          <Form.Label>Folio Crédito</Form.Label>
          <Form.Control
            type="text"
            name="folioCredito"
            placeholder="Folio crédito"
            value={values.folioCredito}
            onChange={handleChange}
            isInvalid={!!errors.folioCredito && touched.folioCredito}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.folioCredito}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("/")}
        >
          Cancelar
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Guardar
        </button>
      </div>
    </Form>
  );
}

export default FolioFields;
